/* eslint-disable @typescript-eslint/member-ordering */

import { ChangeDetectionStrategy, Component, inject, input, InputSignal, model, ModelSignal } from '@angular/core';
import { IconComponent } from '@libs/components/icons';
import {
  ConfigurableBundleFormStateModel,
  ConfigurableBundleFormStateSlotModel,
  ConfigurableBundleTemplateModel,
  ProductBundleItemModel,
} from '@libs/shop/models';
import { ProductPriceFormatterComponent } from '../../../catalog/product-prices/product-price-formatter';
import { ConfigurableBundleFormUiService } from '../configurable-bundle-form-ui.service';

@Component({
  selector: 'ui-configurable-bundle-form-bundle-item-list',
  imports: [
    ProductPriceFormatterComponent,
    IconComponent,
  ],
  templateUrl: './configurable-bundle-form-bundle-item-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './configurable-bundle-form-bundle-item-list.component.scss',
})
export class ConfigurableBundleFormBundleItemListComponent {
  private readonly configurableBundleFormUiService: ConfigurableBundleFormUiService = inject(ConfigurableBundleFormUiService);

  public bundleTemplate: InputSignal<ConfigurableBundleTemplateModel> = input.required();
  public bundleState: ModelSignal<ConfigurableBundleFormStateModel> = model.required();
  public canSeePrices: InputSignal<boolean> = input.required();

  public bundleItems: InputSignal<ProductBundleItemModel[]> = input.required();

  public removeItem(item: ProductBundleItemModel): void {
    if (!item.slotId) {
      throw new Error('slotId not found');
    }

    const slotMap: Map<string, ConfigurableBundleFormStateSlotModel> = this.bundleState().slotMap;
    let slotState: ConfigurableBundleFormStateSlotModel | undefined = slotMap.get(item.slotId);

    if (!slotState) {
      throw new Error('slot state not found');
    }

    const itemMap: Map<string, ProductBundleItemModel | undefined> = slotState.itemMap;

    itemMap.delete(item.sku);

    slotState = {
      ...slotState,
      itemMap,
    };

    const selectedAmount: number = slotState.selectedAmount - item.quantity;

    slotState = {
      ...slotState,
      selectedAmount: slotState.selectedAmount - item.quantity,
      thresholdStepReachedIndex: this.configurableBundleFormUiService.findThresholdIndex(selectedAmount, slotState.thresholdSteps),
    };

    slotMap.set(slotState.slotId, slotState);
    this.bundleState.set({
      ...this.bundleState(),
      slotMap,
    });
  }
}
